import { Injectable } from '@angular/core';
import { CatBusinessLineModel } from 'src/app/model/cat-business-line.model';
import { CatCategoryPromoterModel } from 'src/app/model/cat-category-promoter.model';
import { CatCollectAmountRangeModel } from 'src/app/model/cat-collect-amount-range.model';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatFeeEmployeejobModel } from 'src/app/model/cat-fee-employee-job-model';
import { CatGoalRegionModel } from 'src/app/model/cat-goal-region.model';
import { CatGoalStateModel } from 'src/app/model/cat-goal-state.model';
import { CatJobPositionBIModel } from 'src/app/model/cat-job-position-bi.model';
import { CatPaymentFrequencyModel } from 'src/app/model/cat-payment-frecuency.model';
import { CatProductModel } from 'src/app/model/cat-product.model';
import { CatAgreementModel } from 'src/app/model/cat-agreement.model';
import { CatSaleTypeModel } from 'src/app/model/cat-sale-type.model';
import { CatSubProductModel } from 'src/app/model/cat-sub-product.model';
import { CatTermModel } from 'src/app/model/cat-term.model';
import { EmployeesModel } from 'src/app/model/employees.model';
import { ComGoalEmployeeJobModel } from 'src/app/model/com-goal-employee-job.model';
import { ComProductCategoryModel } from 'src/app/model/com-product-category.model';
import { ComProductCollectAmountModel } from 'src/app/model/com-product-collect-amount.model';
import { ComProductDealerModel } from 'src/app/model/com-product-dealer.model';
import { ComProductEmployeeJobModel } from 'src/app/model/com-product-employee-job.model';
import { ComProductSharedModel } from 'src/app/model/com-product-shared.model';
import { ComPromoterCategoryModel } from 'src/app/model/com-promoter-category.model';
import { CommissionSalePromotion } from 'src/app/model/commission-sale-promotion';
import { ConversionConfiguration } from 'src/app/model/conversion-configuration';
import { VwCommissionPanelModel } from 'src/app/model/vw-commission-panel.model';
import { PromotorCategoryAssignmentModel } from 'src/app/model/promotor-category-assignment.model';

@Injectable({
  providedIn: 'root'
})
export class CreatorService {
  /////////////////
  constructor() { }

  // catalogos
  newCatBusinessLine=()=> {
    let newCatBusinessLine=new CatBusinessLineModel();
    newCatBusinessLine.iActiveId=1;
    return newCatBusinessLine;
  }
  newCatProduct=()=> {
    let newCatProduct=new CatProductModel();
    newCatProduct.iActiveId=1;
    return newCatProduct;
  }
  newCatSubProduct=()=> {
    let newCatSubProduct=new CatSubProductModel();
    newCatSubProduct.iActiveId=1;
    return newCatSubProduct;
  }
  newCatTerm=()=> {
    let newCatTerm=new CatTermModel();
    newCatTerm.iActiveId=1;
    return newCatTerm;
  }
  newCatCategoryPromoter=()=> {
    let newCatCategoryPromoter=new CatCategoryPromoterModel();
    newCatCategoryPromoter.createUserId=Number(localStorage.getItem('com_token'));
    newCatCategoryPromoter.modifUserId=Number(localStorage.getItem('com_token'));
    newCatCategoryPromoter.activeId=1;
    return newCatCategoryPromoter;
  }
  newCatGoalRegion=()=> {
    let newCatGoalRegion=new CatGoalRegionModel();
    newCatGoalRegion.createUserId=Number(localStorage.getItem('com_token'));
    newCatGoalRegion.modifUserId=Number(localStorage.getItem('com_token'));
    newCatGoalRegion.activeId=true;
    return newCatGoalRegion;
  }
  newCatGoalState=()=> {
    let newCatGoalState=new CatGoalStateModel();
    newCatGoalState.createUserId=Number(localStorage.getItem('com_token'));
    newCatGoalState.modifUserId=Number(localStorage.getItem('com_token'));
    newCatGoalState.activeId=true;
    return newCatGoalState;
  }
  newCatEmployeeJob=()=> {
    let newCatJobPosition=new CatEmployeeJobModel();
    newCatJobPosition.createUserId=Number(localStorage.getItem('com_token'));
    newCatJobPosition.modifUserId=Number(localStorage.getItem('com_token'));
    newCatJobPosition.activeId=true;
    return newCatJobPosition;
  }
  newCatSaleType=()=> {
    let newCatSaleType=new CatSaleTypeModel();
    newCatSaleType.createUserId=Number(localStorage.getItem('com_token'));
    newCatSaleType.activeId=true;
    return newCatSaleType;
  }
  newCatAgreement=()=> {
    let newCatAgreement=new CatAgreementModel();
    newCatAgreement.createUserId=Number(localStorage.getItem('com_token'));
    newCatAgreement.modifUserId=Number(localStorage.getItem('com_token'));
    newCatAgreement.activeId=true;
    return newCatAgreement;
  }
  newCatPaymentFrequency=()=> {
    let newCatPaymentFrequency=new CatPaymentFrequencyModel();
    newCatPaymentFrequency.createUserId=Number(localStorage.getItem('com_token'));
    newCatPaymentFrequency.modifUserId=Number(localStorage.getItem('com_token'));
    newCatPaymentFrequency.activeId=true;
    return newCatPaymentFrequency;
  }
  newCatCategoryProduct=()=> {
    let newCatCategoryProduct=new CatPaymentFrequencyModel();
    newCatCategoryProduct.createUserId=Number(localStorage.getItem('com_token'));
    newCatCategoryProduct.modifUserId=Number(localStorage.getItem('com_token'));
    newCatCategoryProduct.activeId=true;
    return newCatCategoryProduct;
  }
  newCatCollectAmountRange=()=> {
    let newCatCollectAmountRange=new CatCollectAmountRangeModel();
    newCatCollectAmountRange.createUserId=Number(localStorage.getItem('com_token'));
    newCatCollectAmountRange.modifUserId=Number(localStorage.getItem('com_token'));
    newCatCollectAmountRange.activeId=true;
    return newCatCollectAmountRange;
  }
  newCatCommissionCalendar=()=> {
    let newCatCommissionCalendar=new CatCollectAmountRangeModel();
    newCatCommissionCalendar.createUserId=Number(localStorage.getItem('com_token'));
    newCatCommissionCalendar.modifUserId=Number(localStorage.getItem('com_token'));
    newCatCommissionCalendar.activeId=true;
    return newCatCommissionCalendar;
  }
  newCatFeeEmployeeJob=()=> {
    let newCatFeeEmployeeJob=new CatFeeEmployeejobModel();
    newCatFeeEmployeeJob.createUserId=Number(localStorage.getItem('com_token'));
    newCatFeeEmployeeJob.modifUserId=Number(localStorage.getItem('com_token'));
    newCatFeeEmployeeJob.activeId=true;
    return newCatFeeEmployeeJob;
  }
  newCatJobPositionBi=()=> {
    let newCatJobPositionBi=new CatJobPositionBIModel();
    newCatJobPositionBi.createUserId=Number(localStorage.getItem('com_token'));
    newCatJobPositionBi.modifUserId=Number(localStorage.getItem('com_token'));
    newCatJobPositionBi.activeId=true;
    return newCatJobPositionBi;
  }
  newEmployee=()=> {
    let newEmployee=new EmployeesModel();
    newEmployee.iActivo=true;
    return newEmployee;
  }


  // tablas secundarias
  newComProductEmployeeJobModel=()=> {
    let newComProductEmployeeJobModel= new ComProductEmployeeJobModel();
    newComProductEmployeeJobModel.createUserId=Number(localStorage.getItem('com_token'));
    // newComProductEmployeeJobModel.modifUserId=Number(localStorage.getItem('com_token'));
    newComProductEmployeeJobModel.activeId=true;
    return newComProductEmployeeJobModel;
  }
  newComPromoterCategoryModel=()=> {
    let newComPromoterCategoryModel=new ComPromoterCategoryModel();
    newComPromoterCategoryModel.createUserId=Number(localStorage.getItem('com_token'));
    newComPromoterCategoryModel.modifUserId=Number(localStorage.getItem('com_token'));
    newComPromoterCategoryModel.activeId=true;
    return newComPromoterCategoryModel;
  }
  newComGoalEmployeeJobModel=()=> {
    let newComGoalEmployeeJobModel=new ComGoalEmployeeJobModel();
    newComGoalEmployeeJobModel.createUserId=Number(localStorage.getItem('com_token'));
    newComGoalEmployeeJobModel.modifUserId=Number(localStorage.getItem('com_token'));
    newComGoalEmployeeJobModel.activeId=true;
    return newComGoalEmployeeJobModel;
  }
  newComProductCategoryModel=()=> {
    let newComProductCategoryModel=new ComProductCategoryModel();
    newComProductCategoryModel.createUserId=Number(localStorage.getItem('com_token'));
    newComProductCategoryModel.modifUserId=Number(localStorage.getItem('com_token'));
    newComProductCategoryModel.activeId=true;
    return newComProductCategoryModel;
  }
  newComProductSharedModel=()=> {
    let newComProductSharedModel=new ComProductSharedModel();
    newComProductSharedModel.createUserId=Number(localStorage.getItem('com_token'));
    newComProductSharedModel.modifUserId=Number(localStorage.getItem('com_token'));
    newComProductSharedModel.activeId=true;
    return newComProductSharedModel;
  }
  newComProductDealerModel=()=> {
    let newComProductDealerModel=new ComProductDealerModel();
    newComProductDealerModel.createUserId=Number(localStorage.getItem('com_token'));
    newComProductDealerModel.modifUserId=Number(localStorage.getItem('com_token'));
    newComProductDealerModel.activeId=true;
    return newComProductDealerModel;
  }
  newComProductCollectAmountModel=()=> {
    let newComProductCollectAmountModel=new ComProductCollectAmountModel();
    newComProductCollectAmountModel.createUserId=Number(localStorage.getItem('com_token'));
    newComProductCollectAmountModel.modifUserId=Number(localStorage.getItem('com_token'));
    newComProductCollectAmountModel.activeId=true;
    return newComProductCollectAmountModel;
  }

  //
  newVwCommissionPanelModel=()=> {
    let newVwCommissionPanelModel=new VwCommissionPanelModel();
    newVwCommissionPanelModel.activeId=true;
    newVwCommissionPanelModel.userId=Number(localStorage.getItem('com_token'));
    return newVwCommissionPanelModel;
  }

  newCommissionSalePromotion=()=> {
    let newCommissionSalePromotion=new CommissionSalePromotion();
    newCommissionSalePromotion.activeId=true;
    newCommissionSalePromotion.createUserId=Number(localStorage.getItem('com_token'));
    return newCommissionSalePromotion;
  }

  newConversionConfiguration=()=> {
    let newConversionConfiguration=new ConversionConfiguration();
    newConversionConfiguration.activeId=true;
    newConversionConfiguration.createUserId=Number(localStorage.getItem('com_token'));
    return newConversionConfiguration;
  }

  newPromotorCategoryAssignment=()=> {
    let entity=new PromotorCategoryAssignmentModel();
    entity.activeId=true;
    entity.createUserId=Number(localStorage.getItem('com_token'));
    return entity;
  }
}